import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../shared/Services/authentication.service";

export const isLoggedInResolver = () => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    router.navigateByUrl('/login');
  }
  return auth.isLoggedIn();
};

